// extracted by mini-css-extract-plugin
export default {"element":"Raw-module--element--74995","disableMinHeight":"Raw-module--disableMinHeight--ac73e"};